/**
 * Employer-dashboard password rules (Zeal admin / team invite signup, Chakotay reset password, etc.).
 * Keep in sync with La Forge account flows that enforce the same shape in UI.
 */
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 128;

export const SPECIAL_CHARACTERS_REGEX =
  /^(?=.*[!@#$%^&*()_+\-=\x5b\x5d{}|;:’“,.<>?/~`]).+$/;

export const passwordMeetsEmployerPasswordPolicy = (
  password: string
): boolean => {
  if (
    password.length < MIN_PASSWORD_LENGTH ||
    password.length > MAX_PASSWORD_LENGTH
  ) {
    return false;
  }
  if (!/[A-Z]/.test(password)) {
    return false;
  }
  if (!/[a-z]/.test(password)) {
    return false;
  }
  if (!/[0-9]/.test(password)) {
    return false;
  }
  if (!SPECIAL_CHARACTERS_REGEX.test(password)) {
    return false;
  }
  return true;
};
